export const queryKeys = {
  // Client
  clients: ['clients'] as const,
  clientList: (filters: Record<string, any>) => ['clients', 'list', filters] as const,
  senderClientList: (filters: Record<string, any>) => ['clients', 'sender', 'list', filters] as const,
  clientDetail: (id: number | string) => ['clients', 'detail', id] as const,

  // User
  users: ['users'] as const,
  userList: (filters: Record<string, any>) => ['users', 'list', filters] as const,
  userDetail: (id: number | string) => ['users', 'detail', id] as const,
  whoAmI: ['users', 'whoAmI'] as const,

  // Customer
  customers: ['customers'] as const,
  customerList: (filters: Record<string, any>) => ['customers', 'list', filters] as const,
  customerDetail: (id: number | string) => ['customers', 'detail', id] as const,
  customerUser: (userId: number) => ['customers', 'customerUser', userId] as const,

  // Order
  orders: ['orders'] as const,
  orderList: (filters: Record<string, any>) => ['orders', 'list', filters] as const,
  orderDetail: (id: number | string) => ['orders', 'detail', id] as const,

  // Ticket
  tickets: ['tickets'] as const,
  ticketList: (filters: Record<string, any>) => ['tickets', 'list', filters] as const,
  ticketDetail: (id: number | string) => ['tickets', 'detail', id] as const,
  ticketCategories: ['tickets', 'categories'] as const,

  // Address
  addresses: ['addresses'] as const,
  addressList: (filters: Record<string, any>) => ['addresses', 'list', filters] as const,
  addressDetail: (id: number | string) => ['addresses', 'detail', id] as const,

  // Packaging
  packaging: ['packaging'] as const,
  packagingList: (filters: Record<string, any>) => ['packaging', 'list', filters] as const,
  packagingDetail: (id: number | string) => ['packaging', 'detail', id] as const,

  // Parcel
  parcels: ['parcels'] as const,
  parcelList: (filters: Record<string, any>) => ['parcels', 'list', filters] as const,
  parcelDetail: (id: number | string) => ['parcels', 'detail', id] as const,

  // LTL
  ltl: ['ltl'] as const,
  ltlList: (filters: Record<string, any>) => ['ltl', 'list', filters] as const,
  ltlDetail: (id: number | string) => ['ltl', 'detail', id] as const,

  // Voucher / Finance
  vouchers: ['vouchers'] as const,
  voucherList: (filters: Record<string, any>) => ['vouchers', 'list', filters] as const,
  transactions: ['transactions'] as const,
  transactionList: (filters: Record<string, any>) => ['transactions', 'list', filters] as const,

  // Notification
  notifications: ['notifications'] as const,
  notificationList: (filters: Record<string, any>) => ['notifications', 'list', filters] as const,

  // Branch
  branches: ['branches'] as const,
  branchList: (filters: Record<string, any>) => ['branches', 'list', filters] as const,

  // Promotion
  promotions: ['promotions'] as const,
  promotionList: (filters: Record<string, any>) => ['promotions', 'list', filters] as const,

  // Substation
  substations: ['substations'] as const,
  substationList: (filters: Record<string, any>) => ['substations', 'list', filters] as const,

  // Product Type
  productTypes: ['productTypes'] as const,
  productTypeList: (filters: Record<string, any>) => ['productTypes', 'list', filters] as const,

  // Setting / Dashboard
  dashboardStats: ['dashboard', 'stats'] as const,
  contractAmount: ['dashboard', 'contractAmount'] as const,

  // Terms & Conditions
  termsAndConditions: ['termsAndConditions'] as const,
  termsAndConditionsList: (filters: Record<string, any>) => ['termsAndConditions', 'list', filters] as const,
};
